import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, scrollToId } from "@/data/site";
import { Eyebrow, Reveal } from "./Reveal";

const ServiceRow = ({ s, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  const flip = i % 2 === 1;

  return (
    <Reveal className="grid items-center gap-8 lg:grid-cols-12 lg:gap-14" data-testid={`service-${s.no}`}>
      <div ref={ref} className={`relative aspect-[4/3] overflow-hidden rounded-[28px] lg:col-span-7 ${flip ? "lg:order-2" : ""}`}>
        <motion.img src={s.img} alt={s.title} style={{ y, scale: 1.18 }} className="h-full w-full object-cover" />
        <span className="absolute left-5 top-5 rounded-full bg-white/90 px-4 py-1.5 font-display text-sm font-black text-[var(--leaf)] backdrop-blur">{s.no}</span>
      </div>
      <div className="lg:col-span-5">
        <span className="font-serif-i text-6xl text-[var(--leaf)]/30">{s.no}.</span>
        <h3 className="mt-2 font-display text-3xl font-black leading-[0.95] sm:text-4xl">{s.title}</h3>
        <p className="mt-5 text-base leading-relaxed text-[var(--muted)]">{s.text}</p>
        <div className="mt-6 flex flex-wrap gap-2">
          {s.tags.map((t) => <span key={t} className="rounded-full bg-[var(--sprout)] px-3.5 py-1.5 text-xs font-bold text-[var(--leaf-deep)]">{t}</span>)}
        </div>
        <button data-testid={`service-${s.no}-cta`} onClick={() => scrollToId("contact")} className="group mt-8 inline-flex items-center gap-2 font-bold text-[var(--leaf)]">
          Schedule a consultation
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
        </button>
      </div>
    </Reveal>
  );
};

export const Services = () => (
  <section id="services" data-testid="services-section" className="bg-white py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-16 grid gap-6 lg:mb-24 lg:grid-cols-2 lg:items-end">
        <div>
          <Eyebrow>What we do</Eyebrow>
          <h2 className="mt-5 font-display text-4xl font-black leading-[0.95] sm:text-6xl">Three crafts. <span className="font-serif-i font-normal text-[var(--leaf)]">One standard.</span></h2>
        </div>
        <p className="max-w-md text-base text-[var(--muted)] md:text-lg lg:justify-self-end">From weekly upkeep to hardscape builds, every job gets the same care — tailored to the unique vision of each client.</p>
      </Reveal>
      <div className="space-y-20 lg:space-y-32">
        {SERVICES.map((s, i) => <ServiceRow key={s.no} s={s} i={i} />)}
      </div>
    </div>
  </section>
);
